import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7c323e88"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "VvicItem" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "shopList flex" }
const _hoisted_4 = { class: "imgBox" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"width":"100%"},
  src: "https://static-s.theckb.com/BusinessMarket/Client/shop_img_back.png",
  alt: ""
}, null, -1))
const _hoisted_6 = { class: "cn-price" }
const _hoisted_7 = { class: "other-price" }

import { computed } from 'vue'
import SvgIcon from '@/components/icons/SvgIcon.vue'
import { isKO, useRtfix, useSite2Station } from '@/store'
import { calc, formatMoneyDirection } from '@/util/useYan'
import { Site } from '@/common/const'
import { t } from '@/plugins/i18n'
import router from '@/router'

export default /*#__PURE__*/_defineComponent({
  props: ['vvicItem'],
  setup(__props) {

const prop = __props


const stationCode = useSite2Station()

const nVvicItem = computed(() => {
  const vvicItem = prop?.vvicItem ?? {}
  const label = {
    [Site.JA]: vvicItem.cateNameJp,
    [Site.KO]: vvicItem!.cateNameKo,
    [Site.EN]: vvicItem!.cateNameEn
  }[stationCode] as string
  return {
    ...vvicItem,
    showCateName: label ?? vvicItem?.cateName,
    productRespDTOS: vvicItem?.productRespDTOS?.slice(0, 4)
  }
})

return (_ctx: any,_cache: any) => {
  const _component_el_image = _resolveComponent("el-image")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createTextVNode(_toDisplayString(_unref(nVvicItem).showCateName) + " ", 1),
      _createVNode(SvgIcon, { name: "market_arrow_right" })
    ]),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(nVvicItem).productRespDTOS, (item) => {
        return (_openBlock(), _createElementBlock("div", {
          key: item.productCode,
          class: "shopItem"
        }, [
          (item.sort < 4 && item.sort)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(["rank", `rank${item.sort}`])
              }, "#" + _toDisplayString(item.sort), 3))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_el_image, {
              referrerpolicy: "no-referrer",
              class: "img",
              src: item.productMainImgUrl,
              alt: ""
            }, {
              error: _withCtx(() => [
                _hoisted_5
              ]),
              _: 2
            }, 1032, ["src"])
          ]),
          _createElementVNode("div", {
            class: "goods-item-price line--only",
            style: _normalizeStyle(`color: ${_unref(isKO)() ? '#333333' : 'red'};`)
          }, [
            _createElementVNode("span", _hoisted_6, _toDisplayString(`${item.productPrice}${_unref(t)("元")}`), 1),
            _createElementVNode("span", _hoisted_7, _toDisplayString(`（${_unref(formatMoneyDirection)(_unref(calc)(item.productPrice))}）`), 1)
          ], 4)
        ]))
      }), 128))
    ])
  ]))
}
}

})